"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerkleDistributorFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MerkleDistributorFactory = /** @class */ (function (_super) {
    __extends(MerkleDistributorFactory, _super);
    function MerkleDistributorFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MerkleDistributorFactory.prototype.deploy = function (token_, merkleRoot_, overrides) {
        return _super.prototype.deploy.call(this, token_, merkleRoot_, overrides || {});
    };
    MerkleDistributorFactory.prototype.getDeployTransaction = function (token_, merkleRoot_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, token_, merkleRoot_, overrides || {});
    };
    MerkleDistributorFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MerkleDistributorFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MerkleDistributorFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MerkleDistributorFactory;
}(contracts_1.ContractFactory));
exports.MerkleDistributorFactory = MerkleDistributorFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "token_",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "merkleRoot_",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "active",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "switchActive",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
